@if (result(); as item) {
  <soft-ktostamm-kunde-field-ok-data-view
    [item]="item"
  ></soft-ktostamm-kunde-field-ok-data-view>
}
